var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.9999 10.6666H22.6666V7.99998C22.6666 4.31998 19.6799 1.33331 15.9999 1.33331C12.3199 1.33331 9.33325 4.31998 9.33325 7.99998V10.6666H7.99992C6.53325 10.6666 5.33325 11.8666 5.33325 13.3333V26.6666C5.33325 28.1333 6.53325 29.3333 7.99992 29.3333H23.9999C25.4666 29.3333 26.6666 28.1333 26.6666 26.6666V13.3333C26.6666 11.8666 25.4666 10.6666 23.9999 10.6666ZM15.9999 22.6666C14.5333 22.6666 13.3333 21.4666 13.3333 20C13.3333 18.5333 14.5333 17.3333 15.9999 17.3333C17.4666 17.3333 18.6666 18.5333 18.6666 20C18.6666 21.4666 17.4666 22.6666 15.9999 22.6666ZM11.9999 10.6666V7.99998C11.9999 5.78665 13.7866 3.99998 15.9999 3.99998C18.2133 3.99998 19.9999 5.78665 19.9999 7.99998V10.6666H11.9999Z",
    fill: "#525252"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocks);
export default __webpack_public_path__ + "static/media/locks.e37457d525e088293be3da0f36a64f48.svg";
export { ForwardRef as ReactComponent };